export default __webpack_public_path__ + "static/media/mountains.ad8744c0.glb";